import { useEffect } from 'react';
import useEventCallback from '@jwp/ott-hooks-react/src/useEventCallback';

import { getScrollParent } from '../utils/dom';

export const useScrolledDown = (start = 300, end = 30, onChange: (progress: number) => void) => {
  const handleScroll = useEventCallback(() => {
    const scrollTarget = getScrollParent();
    const scrollPosition = scrollTarget.scrollTop;
    const progress = Math.max(0, Math.min(1, (scrollPosition - start) / (end - start)));

    onChange(progress);
  });

  useEffect(() => {
    const scrollElement = getScrollParent();
    const scrollTarget = scrollElement === document.documentElement ? window : scrollElement;
    scrollTarget.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();
    return () => {
      scrollTarget.removeEventListener('scroll', handleScroll);
    };
  }, [handleScroll]);
};
